import { Component, Input, OnInit } from '@angular/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { handleUploadEvent } from '@data/data.module.types';

function secondsToString(secs: number): string {
  secs = Math.round(secs);

  let timeStr = '' + (secs % 60) + '';

  if (secs >= 60) {
    timeStr = Math.floor(secs / 60) + ':' + timeStr;
  } else {
    timeStr += 's';
  }
  return timeStr;
}
@Component({
  selector: 'app-upload-progress-bar',
  templateUrl: './upload-progress-bar.component.html'
})
export class UploadProgressBarComponent implements OnInit {

  startAt?: Date;

  intId: any;

  updates = 0;

  progress = 0;

  progressStr = '0 %';

  loaded: string = '?';

  loadedInt = 0;

  total: string = '?';

  totalInt = 0;

  showTime = false;

  time = '';

  mode: ProgressBarMode = "determinate";

  timeAfter = 2;

  @Input() set data(data: any) {
    if (data) {
      ++this.updates;

      if (!this.startAt) {
        this.startAt = new Date();

        this.intId = setInterval(() => {
          const curTime = (new Date()).getTime();
          let diff = Math.floor((curTime - this.startAt!.getTime()) / 1000);

          if (diff > this.timeAfter) {
            if (this.progress < 100) {
              this.showTime = true;
              let time = secondsToString(diff);

              if (this.loadedInt > 0) {
                let est = this.totalInt / (this.loadedInt / diff);
                time += ' von ' + secondsToString(est);
              }
              this.time = time;
            } else {
              this.time = secondsToString(diff);
              this.progressStr = 'Warten auf Server ...';
              this.mode = "indeterminate";
            }
          }
        }, 1000);
      }

      const progress = handleUploadEvent(data);

      if (progress) {
        this.loadedInt = data.loaded;
        this.totalInt = data.total;

        this.progress = progress.progress;
        this.progressStr = this.progress + '%';
        this.loaded = progress.loaded;
        this.total = progress.total;
      }
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.intId && clearInterval(this.intId);
  }

}
